import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 对账规则查询
export function queryRuleList(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.queryRuleList,
    method: 'post',
    data
  })
}

// 匹配字段列表查询
export function matchFieldList(ruleUuid) {
  return request({
    url: URL.act.reconciliation.matchFieldList,
    method: 'get',
    params: { ruleUuid }
  })
}

// 对比字段列表查询
export function compareFieldList(ruleUuid) {
  return request({
    url: URL.act.reconciliation.compareFieldList,
    method: 'get',
    params: { ruleUuid }
  })
}

// 保存对账规则
export function saveRule(data) {
  return request({
    url: URL.act.reconciliation.saveRule,
    method: 'post',
    data
  })
}

// 保存匹配规则
export function saveRuleMatch(data) {
  return request({
    url: URL.act.reconciliation.saveRuleMatch,
    method: 'post',
    data
  })
}

// 保存对比规则
export function saveRuleOperation(data) {
  return request({
    url: URL.act.reconciliation.saveRuleOperation,
    method: 'post',
    data
  })
}

// 编辑对账规则
export function updateRule(data) {
  return request({
    url: URL.act.reconciliation.updateRule,
    method: 'put',
    data
  })
}

// 编辑对账规则里匹配字段
export function updateRuleMatch(data) {
  return request({
    url: URL.act.reconciliation.updateRuleMatch,
    method: 'put',
    data
  })
}

// 编辑对账规则里对比字段
export function updateRuleOperation(data) {
  return request({
    url: URL.act.reconciliation.updateRuleOperation,
    method: 'put',
    data
  })
}

// 删除对账规则
export function deleteRule(data) {
  return request({
    url: URL.act.reconciliation.deleteRule,
    method: 'delete',
    data
  })
}

// 删除对账规则里匹配字段
export function deleteRuleMatch(data) {
  return request({
    url: URL.act.reconciliation.deleteRuleMatch,
    method: 'delete',
    data
  })
}

// 删除对账规则里对比字段
export function deleteRuleOperation(data) {
  return request({
    url: URL.act.reconciliation.deleteRuleOperation,
    method: 'delete',
    data
  })
}

// 获取匹配字段名称、对比字段下拉数据
export function queryTableColumnName() {
  return request({
    url: URL.act.reconciliation.queryTableColumnName,
    method: 'get'
  })
}
